/* eslint-disable react/prop-types */
import ImageConsultFinish from 'Assets/images/pages/web-chat/consult_finish.svg';
import classNames from 'classnames';
import { shape } from 'prop-types';
import React, { useState } from 'react';
import { Image, Segment } from 'semantic-ui-react';

import style from '../MessageBot.less';

import ModalBotFinishConsult from './ModalBotFinishConsult';

// eslint-disable-next-line max-len
const findItemFee = contents => contents?.find(item => item.key === 'finish_consult_total_fee'); // finish_consult_total_fee

const MessageFinishConsult = props => {
  const [isOpenDetails, setOpenDetails] = useState(false);
  const { message, isDoctor, isBot } = props;

  const {
    message: { attachment },
  } = message;
  const content = attachment?.content;
  const infoFee = findItemFee(content);
  const fee = infoFee?.body || '';
  const toggleOpenDetails = () => setOpenDetails(prev => !prev);
  return (
    <div
      className={classNames({
        'bot-message': true,
        'message-finish': true,
        'text-right': isDoctor || isBot,
      })}>
      <Segment.Group className="content" onClick={toggleOpenDetails}>
        <div className={style.content}>
          <div className={style.left}>
            <div className={style.title}>Consult Details</div>
            {/* <div className={style.meta}>{formatDate(sentAt, 'MMM DD, YYYY HH:mm')}</div> */}
          </div>
          <div className={style.icon}>
            <Image style={{ top: -4 }} src={ImageConsultFinish} />
          </div>
        </div>
        <div>
          <div className={style.bodyAction}>
            <div className="info">
              <span>Total Fee</span>
              <span>{fee}</span>
            </div>
          </div>
        </div>
      </Segment.Group>
      {isOpenDetails && <ModalBotFinishConsult message={message} close={toggleOpenDetails} />}
    </div>
  );
};

MessageFinishConsult.propTypes = {
  message: shape({}).isRequired,
};

export default MessageFinishConsult;
